import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CourseComponent } from './course.component';

const routes: Routes = [
  { path: ':lang/course/:name/:id', component: CourseComponent },
  { path: ':lang/opintojakso/:name/:id', component: CourseComponent },
  { path: ':lang/kurs/:name/:id', component: CourseComponent },
  { path: 'fi/jakso/:id', component: CourseComponent }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CourseRoutingModule { }
